export { default } from "./ReductionsItem.component";
